import styled from 'styled-components';
import { colors } from '../../../theme';

/* Footer of the card, left aligned. The auto margin keeps it at the bottom
   when the card is stretched by its neighbours. */
export const EvolutionLegendStyled = styled.div`
    display: flex;
    align-items: center;
    align-self: flex-start;
    gap: 6px;
    margin-top: auto;
    padding-top: 16px;
`;

export const EvolutionLegendIconsStyled = styled.span`
    display: flex;
    align-items: center;
    gap: 4px;
    /* The files carry their fill on each path, the legend color overrides it there. */
    path {
        fill: ${colors.grey400};
    }
`;
